import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { EndpointResolverService } from './endpoint-resolver.service';
import { Observable } from 'rxjs';


@Injectable()
export class ApiService {

  constructor(private readonly client: HttpClient, private readonly oAuth: OAuthService, private readonly ep: EndpointResolverService) {

  }

  public resource(name: string) {
    const ep = this.getUrl(name);
    if (!ep) {
      throw Error(`cannot resolve end-point for: [${name}]`);
    }
    return {
      list: (params?: any) => {
        return this.list(ep, params);
      },
      load: (id: string) => {
        return this.load(`${ep}/${id}`);
      },
      save: (model?: object, id?: string) => {
        return this.save(ep, model, id);
      },
      post: (model?: object) => {
        return this.post(ep, model);
      },
      patch: (id: string, model?: object) => {
        return this.patch(ep, model);
      },
      delete: (id: string) => {
        return this.delete(ep);
      }
    };
  }

  public list(url?: string, params?: HttpParams | { [param: string]: string | string[] }) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    // .set('Authorization', `Bearer ${this.oauthService.getAccessToken()}`);
    return this.client.get(url, { headers, params });
  }

  public load(url?: string) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    //   .set('Authorization', `Bearer ${this.oauthService.getAccessToken()}`);
    return this.client.get(url, { headers });
  }

  public save(url: string, model: object, id?: any) {
    if (!id) {
      return this.post(url, model);
    } else {
      return this.patch(`${url}/${id}`, model);
    }
  }

  public post(url: string, model?: object) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    // .set('Authorization', `Bearer ${this.oauthService.getAccessToken()}`);
    return this.client.post(url, model, { headers });
  }

  public patch(url: string, model?: object) {

    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    // .set('Authorization', `Bearer ${this.oauthService.getAccessToken()}`);
    return this.client.patch(url, model, { headers });
  }

  public delete(url: string) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    //   .set('Authorization', `Bearer ${this.oauthService.getAccessToken()}`);
    return this.client.delete(url, { headers });
  }

  public download(uri: string): Observable<Blob> {
        return this.client.get(uri, { responseType: 'blob' });
    }

  //#region url resolutions
  public getUrl(name: string): string {
    const ep = this.ep.getUrl(name);
    return ep;
  }


  public getAccessToken(): string {
    return this.oAuth.getAccessToken();
  }
  //#endregion
}

export const Resource = {
  MENU: 'menu',
  COUNTRY: 'countries',
  CAMPAIGN: 'campaigns',
  CAMPAIGN_STATUS: 'campaign_statuses',
  COMPANY: 'companies',
  FILE: 'files',
  EXPORT: 'exports',
  IMPORT: 'imports',
  VAULT: 'vaults',
  VENDOR: 'vendors',
  VOUCHER_TRANSFER: 'voucher_transfers',
  REQUEST_LOG: 'request_logs',
  REQUEST_LOG_TYPES: 'request_log_types',
  SYSTEM_STATISTICS_ACTIVE_CAMPAIGNS: 'system_statistics_active_campaigns',
  SYSTEM_STATISTICS_SUMMARY_DAILY: 'system_statistics_summary_daily',
  SYSTEM_STATISTICS_VAULT_AVAILABLE: 'system_statistics_vault_available',
  SYSTEM_STATISTICS_VAULT_EXPIRING: 'system_statistics_vault_expiring',
};
